var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isDocumentLtr && !_vm.isDestroyable)?_c('div',{ref:"horizontalScroll",staticClass:"ebx-horizontal-scroll-type"},[_c('div',{staticClass:"ebx-horizontal-scroll-type__scroll"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }